import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEdit, FaTrash, FaEyeSlash } from "react-icons/fa";
import { FaKey } from "react-icons/fa";
import {
  getStaffList,
  deleteStaff,
  updateStaffStatus
} from "../../redux/services/Staff Services/Staff.Services";
import { openModal } from "../../redux/features/modalSlice";
import Pagination from "../../common/Pagination";
import { openStaffModal } from "../../redux/features/staffModalSlice";
import { successToast, errorToast } from "../../Utils/toast";
import { useDispatch } from "react-redux";
function StaffList() {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [showPasswords, setShowPasswords] = useState({});
  const [initialLoading, setInitialLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [totalLeads, setTotalLeads] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const role = localStorage.getItem("role");
  const isAdmin = role === "admin";
  const fetchStaff = async (pageNo = 1, isInitialLoad = false) => {
    try {
      if (isInitialLoad) {
        setInitialLoading(true);
      } else {
        setTableLoading(true);
      }
      const payload = {
        page: pageNo,
        per_page: limit,
      };
      const res = await getStaffList(payload);
      setStaff(res?.data || []);
      setPage(res?.current_page || 1);
      setTotalPages(res?.last_page || 1);
      setTotalLeads(res?.total || 0);
    } catch (error) {
      console.log(error);
      errorToast("Failed to load staff");
    } finally {
      setInitialLoading(false);
      setTableLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchStaff();
  // }, []);

  useEffect(() => {
    fetchStaff(1, true);
  }, [limit]);
  const togglePassword = (id) => {
    setShowPasswords((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleDelete = async (id) => {
    try {
      const res = await deleteStaff({ id });
      if (res?.success) {
        successToast(res?.message);
        fetchStaff(page);
      } else {
        errorToast(res?.message);
      }
    } catch (error) {
      errorToast(error?.message || "Delete failed");
    }
  };
  const handlePageChange = (newPage) => {
    if (
      newPage >= 1 &&
      newPage <= totalPages &&
      !tableLoading
    ) {
      setPage(newPage);
      fetchStaff(newPage, false);
    }
  };
  // STATUS TOGGLE
  //   const handleStatus = async (item) => {
  //     try {
  //       const res = await updateStaffStatus({
  //         id: item.id,
  //        status: item.status ? "active" : "inactive",
  //       });
  // console.log("srrrijiiii,,,,res",res)
  //       successToast(res?.message || "Status updated");

  //       fetchStaff();
  //     } catch (error) {
  //       errorToast("Status update failed");
  //     }
  //   };

  const handleStatusToggle = async (item) => {
    try {
      // const newStatus = (item.status === "active" || item.status === 1)
      //   ? 0
      //   : 1;
      const newStatus = item.status?.toLowerCase() === "active"
        ? "inactive"
        : "active";
      const payload = {
        id: item.id || item._id,
        status: newStatus,
      };
      const res = await updateStaffStatus(payload);
      successToast(res?.message || "Status updated");
      fetchStaff(page);
    } catch (error) {
      errorToast("Status update failed");
    }
  };
  if (initialLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  return (
    <div>


      <div className="d-flex  align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Employee  List</h4>
        </div>
        <button
            className="btn btn-primary"
            onClick={() => navigate("/add-staff")}
            // onClick={() =>
            //   dispatch(
            //     openModal({
            //       type: "add-staff",
            //       title: "Add Staff",
            //       data: {
            //       refreshData: () => fetchStaff(),
            //       },
            //     })
            //   )
            // }

          >
            Add Employee
          </button> 
        {/* <button
          className="add-btn"
          onClick={() =>
            dispatch(
              openStaffModal({
                refreshData: fetchStaff,
              })
            )
          }
        >
          Add Employee
        </button> */}
      </div>
        <div className="main_page">
            {totalPages > 1 && (
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">

          {/* <div className="d-flex align-items-center gap-2">
    <label className="mb-0">Show</label>

    <select
      className="form-select form-select-sm"
      value={limit}
      onChange={(e) => {
        setLimit(Number(e.target.value));
        setPage(1);
      }}
    >
      <option value={10}>10</option>
      <option value={25}>25</option>
      <option value={50}>50</option>
      <option value={100}>100</option>
    </select>
  </div> */}

          <div className="col-12 d-flex justify-content-end">

            <Pagination
              page={page}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>

        </div>
      )}
      {/* TABLE */}
      <div className="st-wrapper-card text-center">
        <div className="st-table-responsive">
          <table className="table st-custom-table align-middle mb-0">

            <thead>
              <tr>
                <th>Name</th>
                <th>EmpId</th>
                <th>Email</th>
                <th>Password</th>
                <th>Mobile</th>
                <th>Role</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>

              {tableLoading ? (
                <tr>
                  <td colSpan="8" className="text-center py-5">
                    <div className="spinner-border text-primary"></div>
                  </td>
                </tr>
              ) : (


                staff.map((item) => (
                  <tr key={item.id}>

                    <td>{item?.name}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{item?.staff_detail?.employee_id}</td>
                    <td>{item?.email}</td>
                    <td>
                      <div className="d-flex align-items-center justify-content-center gap-2">
                        <span>
                          {showPasswords[item.id]
                            ? item.simple_pass
                            : "••••••"}
                        </span>

                        <button
                          type="button"
                          className="btn btn-sm p-0 border-0 bg-transparent"
                          onClick={() => togglePassword(item.id)}
                        >
                          {showPasswords[item.id] ? (
                            <FaEyeSlash />
                          ) : (
                            <FaEye />
                          )}
                        </button>
                      </div>
                    </td>
                    <td>{item.staff_detail?.mobile}</td>
                    <td>{item.role}</td>

                    {/* STATUS */}
                    <td style={{ width: "150px" }}>
                      <div className="city-status-switch">

                        <input
                          type="checkbox"
                          id={`status-${item._id || item.id}`}
                          className="city-status-input justify-content-center"
                          checked={
                            item.status === "active" ||
                            item.status === 1 ||
                            item.status === true
                          }
                          onChange={() => handleStatusToggle(item)}
                        />

                        <label
                          htmlFor={`status-${item._id || item.id}`}
                          className="city-status-label"
                        >
                          <span className="city-status-ball"></span>

                          <span className="city-status-text">
                            {(item.status === "active" || item.status === 1)
                              ? "Active"
                              : "Inactive"}
                          </span>

                        </label>

                      </div>
                    </td>
                    <td >
                      <div className="d-flex align-items-center justify-content-center gap-1">
                        <button
                          className="st-action-btn st-view-btn"
                          onClick={() =>
                            navigate(`/view-staff/${item.id}`)
                          }
                        >
                          <FaEye />
                        </button>

                        <button
                          className="st-action-btn st-edit-btn"
                          onClick={() =>
                            navigate(`/update-staff/${item.id}`)
                          }
                        >
                          <FaEdit />
                        </button>
                        {isAdmin && (
                          <button
                            className="st-action-btn st-view-btn"
                            onClick={() =>
                              dispatch(
                                openModal({
                                  type: "staff-change-password",
                                  title: "Change Employee Password",
                                  data: {
                                    staffId: item.id,
                                    staffName: item.name,
                                    staffOldPassword: item.simple_pass,
                                    refreshData: fetchStaff,
                                  },
                                })
                              )
                            }
                          >
                            <FaKey />
                          </button>
                        )}
                        <button
                          className="st-action-btn st-delete-btn"
                          onClick={() =>
                            dispatch(
                              openModal({
                                type: "delete-staff",
                                title: "Delete Employee",
                                data: {
                                  id: item.id,
                                  deleteFunction: deleteStaff,
                                  // refreshData: fetchStaff,
                                  refreshData: () => fetchStaff(page),
                                },
                              })
                            )
                          }
                        >
                          <FaTrash />
                        </button>
                      </div>


                    </td>

                  </tr>
                ))
              )}

            </tbody>

          </table>
          {totalPages > 1 && (
            <div className="d-flex justify-content-end mt-3">
              <Pagination
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>

      </div>
        </div>

    </div>


  );
}

export default StaffList;